import { GcTableColumn } from '@ip-only/front-end-library';

const plotDesignColumn: GcTableColumn = {
  columnKey: 'plotDesign',
  headerText: 'ordersOverview.tableHeaders.plotDesignDate',
  alignment: 'left',
  cellTemplate: true,
};
const plotExcavationColumn: GcTableColumn = {
  columnKey: 'plotExcavation',
  headerText: 'ordersOverview.tableHeaders.plotExcavationDate',
  alignment: 'left',
  cellTemplate: true,
};
const ductConnectionColumn: GcTableColumn = {
  columnKey: 'ductConnection',
  headerText: 'ordersOverview.tableHeaders.ductConnection',
  alignment: 'left',
  cellTemplate: true,
};
const cableBlowingColumn: GcTableColumn = {
  columnKey: 'cableBlowing',
  headerText: 'ordersOverview.tableHeaders.cableBlowingDate',
  alignment: 'left',
  cellTemplate: true,
};
const addressColumn: GcTableColumn = {
  columnKey: 'address',
  headerText: 'ordersOverview.tableHeaders.address',
  alignment: 'left',
  sortable: true,
};
const macNetAdminIdColumn: GcTableColumn = {
  columnKey: 'macNetAdminId',
  headerText: 'ordersOverview.tableHeaders.macNetAdminId',
  alignment: 'left',
  cellTemplate: true,
};
const installationDateColumn: GcTableColumn = {
  columnKey: 'installationDate',
  headerText: 'ordersOverview.tableHeaders.customerInstallationDate',
  alignment: 'left',
};
const preinstallationColumn: GcTableColumn = {
  columnKey: 'preinstallation',
  headerText: 'ordersOverview.tableHeaders.preinstallationDate',
  alignment: 'left',
  cellTemplate: true,
};
const splicingMeasuringColumn: GcTableColumn = {
  columnKey: 'splicingMeasuring',
  headerText: 'ordersOverview.tableHeaders.splicingAndMeasuringDate',
  alignment: 'left',
  cellTemplate: true,
};
const commissioningColumn: GcTableColumn = {
  columnKey: 'commissioning',
  headerText: 'ordersOverview.tableHeaders.commissioningDate',
  alignment: 'left',
  cellTemplate: true,
};

const nameColumn: GcTableColumn = {
  columnKey: 'name',
  headerText: 'ordersOverview.tableHeaders.buildingName',
  alignment: 'left',
  cellTemplate: false,
};

const buildingIdColumn: GcTableColumn = {
  columnKey: 'buildingId',
  headerText: 'ordersOverview.tableHeaders.buildingId',
  alignment: 'left',
  cellTemplate: false,
};

const statusColumn: GcTableColumn = {
  columnKey: 'status',
  headerText: 'installationReportingMduTable.headers.status',
  alignment: 'left',
  cellTemplate: true,
};

export const buildingColumns: GcTableColumn[] = [
  nameColumn,
  statusColumn,
  buildingIdColumn,
  plotDesignColumn,
  preinstallationColumn,
  plotExcavationColumn,
  ductConnectionColumn,
  cableBlowingColumn,
  splicingMeasuringColumn,
  commissioningColumn,
];

export const deliveryPointColumns: GcTableColumn[] = [
  addressColumn,
  statusColumn,
  buildingIdColumn,
  macNetAdminIdColumn,
  installationDateColumn,
  preinstallationColumn,
  splicingMeasuringColumn,
  commissioningColumn,
];
